import {
  Typography as TypographyCore,
  AccordionDetails as AccordionDetailsComponent,
} from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Container = lib.styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: ${colors.white};
    z-index: 999;
    top: 0px;
`;

export const Header = lib.styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 15px;
    font-weight: 700;
    color: ${colors.darkGray11};
`;

export const Button = lib.styled.div`
    cursor: pointer;
    color: ${colors.darkGray11};
`;

export const Body = lib.styled.div`
    display: flex;
    height: 80%;
    margin: 10px 10px 0 10px;
`;

export const RowItem = lib.styled.div`
    display: flex;
    padding-right: 5px;
    padding-left: 5px;
    cursor: pointer;
    font-size: 12px;
`;

export const TemplateName = lib.styled(TypographyCore)`
  font-weight: 500;
  width: 25ch; /* ~23 characters */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const NoTemplateFound = lib.styled(TypographyCore)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Usage = lib.styled.span`
    flex: 0 0 45px;
    font-weight: 700;
    font-size: 14px;
    color: ${colors.darkGray11};
    text-transform: uppercase;
`;

export const Loader = lib.styled.div`
    display: flex;
    margin-left: -10px;
    align-items: center;
    justify-content: center;
`;

export const TemplateContent = lib.styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const AccordionDetails = lib.styled(AccordionDetailsComponent)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const TextField = lib.styled.input`
  outline: none;
  border: 1px solid ${colors.lightGray17};
  border-radius: 7px;
  height: 40px;
  text-align: center;
  width: 93%;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${colors.darkGray11};

  margin-left: 15px;
  margin-bottom: 15px;

  &::placeholder {
    text-align: center;
    font-style: italic;
    font-family: Nunito;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
`;
